module.exports = __webpack_public_path__ + "static/ideal-ca1887ad2adaa621a8acb1df3f896306.png";